var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    stroke: "#9BAEBC",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8711 3.61289C19.3979 3.79736 19.75 4.29411 19.75 4.85234V13.0184C19.75 15.3008 18.9205 17.4795 17.4556 19.1674C16.7189 20.0174 15.7869 20.6793 14.7971 21.2147L10.5072 23.532L6.21018 21.2135C5.21911 20.6781 4.28591 20.0174 3.54803 19.1662C2.08192 17.4782 1.25 15.2984 1.25 13.0136V4.85234C1.25 4.29411 1.60206 3.79736 2.12894 3.61289L10.0647 0.82415C10.3469 0.725283 10.6543 0.725283 10.9353 0.82415L18.8711 3.61289Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36523 11.8051L9.64639 14.0874L14.3461 9.3877",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldDone);
export default __webpack_public_path__ + "static/media/ShieldDone.d753508b3ab4490c7d03cd1aa09a0890.svg";
export { ForwardRef as ReactComponent };